import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { forkJoin, Subject } from "rxjs";
import { Agent, AgentClient, AgentService, AgentServicesClient, DeliverService, DeliverServicesClient, DocumentClient, Documents, DocumentServices, DocumentTypeClient, DocumentTypes, Material, MaterialClient, MechanisationClient, Mechanisations, NServices, ServiceClient, Unit, VIKUnitClient } from "src/app/web-api-client";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-mechanisation-edit',
  templateUrl: './mechanisation-edit.component.html',
  styleUrls: ['./mechanisation-edit.component.scss']
})
export class MechanisationEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: Mechanisations;   
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, public client: MechanisationClient) { }

  ngOnInit(): void { 
    
      this.initializeForm();
      this.isLoaded = true;
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      description: [this.editObject.description, Validators.required],  
      totalQuantity: [this.editObject.totalQuantity, Validators.required],
      isActive: [this.editObject.isActive, Validators.required]
    });
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {

      this.editObject.title = this.Form.value.title;
      this.editObject.description = this.Form.value.description; 
      this.editObject.totalQuantity = this.Form.value.totalQuantity; 
      this.editObject.isActive = this.Form.value.isActive;



      this.client.update(this.editObject).subscribe((user) => {

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public isSelected(service:Material) {
    let result = this.editObject.id == service.id;
    return result;
  }
  

}
